import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/annualPackage",
    name: "annualPackage",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/annualPackage.vue"),
  },
  {
    path: "/jwActivity",
    name: "jwActivity",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/jwActivity.vue"),
  },
  {
    path: "/jwRank",
    name: "jwRank",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/jwRank.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
